import videoVimeo from "./videoVimeo";

let product = {
    init() {
        if($('body').hasClass('page-type-product')){
            product.video();

            setTimeout(function(){
                product.wishlist();
            }, 300);
        }
    },
    video() {
        $('.product-video .icon-play').click(function(){
            window.idPV = $(this).parent().find('video').attr('id');
            console.log('plop',window.idPV);
            videoVimeo.videoPlay(window.idPV);
            $(this).fadeOut(300);
        })
    },
    wishlist() {
        $('.wishlist').appendTo('.variation .form-actions');
        $('.wishlist').addClass('show');
    }

}

export default product;
